import { IFieldEditorAttachment } from '@/shared/types/fieldEditor';
import type { Image } from 'mdast';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';
import { Node } from 'unist';
import { visit } from 'unist-util-visit';
import { getBaseUrl } from '../url';

export const updateMarkdownImageUrls = (markdown: string, attachments: IFieldEditorAttachment[]): string => {
  const processor = unified().use(remarkParse).use(remarkGfm).use(remarkStringify);

  const tree = processor.parse(markdown);

  const attachmentBaseUrls = attachments.map((att) => ({
    baseUrl: getBaseUrl(att.url),
    fullUrl: att.url
  }));

  visit(tree, (node: Node) => {
    if (node.type === 'image') {
      const imageNode = node as Image;
      const oldBaseUrl = getBaseUrl(imageNode.url);

      const attachment = attachmentBaseUrls.find((att) => att.baseUrl === oldBaseUrl);

      if (attachment) {
        imageNode.url = attachment.fullUrl;
      }
    }

    if (node.type === 'html' && typeof (node as any).value === 'string') {
      const htmlNode = node as any;

      const imgTagRegex = /<img\s+[^>]*src="([^"]+)"[^>]*>/g;

      htmlNode.value = htmlNode.value.replace(imgTagRegex, (match: string, srcUrl: string) => {
        const oldBaseUrl = getBaseUrl(srcUrl);

        const attachment = attachmentBaseUrls.find((att) => att.baseUrl === oldBaseUrl);

        if (attachment) {
          return match.replace(srcUrl, attachment.fullUrl);
        }

        return match;
      });
    }
  });

  return processor.stringify(tree);
};
